import React, { useEffect, useState } from 'react';
import moment from 'moment';

interface CsvData {
  data: string;
  startDate: string;
  endDate: string;
  name: string;
}

interface ReportDownloadProps {
  csv: CsvData;
}

const ReportDownload: React.FC<ReportDownloadProps> = ({ csv }) => {
  const [data, setData] = useState<string | null>(null);
  const [reportName, setReportName] = useState<string>('');

  useEffect(() => {
    if (csv?.data) {
      refreshIfNeeded();
    }
  }, [csv]);

  const refreshIfNeeded = () => {
    if (data && csv.data === data) {
      return;
    }
    refreshReportName();
    refreshData();
  };

  const refreshReportName = () => {
    const startDate = moment(csv.startDate).format('MMMM-DD-YYYY');
    const endDate = moment(csv.endDate).format('MMMM-DD-YYYY');
    const dateRange = startDate === endDate ? startDate : `${startDate}-to-${endDate}`;
    setReportName(`${csv.name}_${dateRange}.csv`);
  };

  const refreshData = () => {
    if (blobSupported()) {
      const blob = new Blob([csv.data], { type: 'text/csv' });
      setData(window.URL.createObjectURL(blob));
    } else {
      setData(csv.data);
    }
  };

  const blobSupported = () => Boolean(window.Blob);

  const downloadReportData = () => {
    if (!document.execCommand) {
      return;
    }

    refreshIfNeeded();
    const downloadWindow = window.open('about:blank', '_blank');
    if (downloadWindow) {
      downloadWindow.document.writeln(data || '');
      downloadWindow.document.close();
      const success = downloadWindow.document.execCommand('SaveAs', true, reportName);
      downloadWindow.close();
      if (!success) {
        console.error('Error downloading ' + reportName);
      }
    }
  };

  return (
    <div>
      {blobSupported() ? (
        <a href={data || '#'} download={reportName}>Download Report Data</a>
      ) : (
        <a onClick={downloadReportData}>Download Report Data</a>
      )}
    </div>
  );
};

export default ReportDownload;